import { apiRequest } from "../apiRequest";
import { useLiteSiteStore } from "../store";

export async function getCampaignScreenshot(id: string) {
  const { url } = await apiRequest<{ url: string }>({ url: `campaigns/${id}/screenshot` });
  useLiteSiteStore.setState(({ campaignScreenshots }) => ({
    campaignScreenshots: { ...campaignScreenshots, [id]: url },
  }));
}
